export default { 
        window: () => window
    };
